<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'
  import bus from '@utils/bus'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          name: '',
          description: '',
          min_size: '',
          max_size: '',
          required: ''
        },
        dependencies: {
          type: [{
            value: 'number',
            label: 'Numérico'
          }, {
            value: 'text',
            label: 'Texto'
          }]
        }
      }
    },
    validations: {
      form: {
        name: {required},
        description: {required},
        type: {required},
        min_size: {required},
        max_size: {required}
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('criteria', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      } else {
        this.isLoadingData = false
        bus.$emit('hide-loader')
      }
    },
    methods: {
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('criteria', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'criteria.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Critério"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados dos Critérios</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     @submit.native.prevent>
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"/>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Descrição"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.description.$error }">
                    <el-input v-model="form.description"
                              @input="$v.form.description.$touch()"/>
                    <div class="el-form-item__error" v-if="$v.form.description.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Tipo"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.type.$error }">
                    <el-select v-model="form.type"
                               placeholder="Selecione..."
                               class="el-select-full"
                               @input="$v.form.type.$touch()">
                        <el-option
                                v-for="item in dependencies.type"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="el-form-item__error" v-if="$v.form.type.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Valor Mínimo"
                              class="is-required">
                    <el-input-number v-model="form.min_size"
                                     :min="0"
                                     :step="1"
                                     :max="100"/>
                </el-form-item>
                <el-form-item label="Valor Máximo"
                              class="is-required">
                    <el-input-number v-model="form.max_size"
                                     :min="0"
                                     :step="1"
                                     :max="100"/>
                </el-form-item>

                <el-form-item label="Obrigatório?">
                    <el-switch
                            v-model="form.required"
                            on-text="SIM"
                            off-text="NÃO">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="criteria.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?58dc1616